'use client';

import {dataLayerEmit} from '@services/gtm/datalayer.service';
import {FC, useEffect} from 'react';

const DataLayerDevicePixelRatio: FC = () => {
    useEffect(() => {
        const pixelRatio = window.devicePixelRatio;

        dataLayerEmit('DevicePixelRatio', {pixelRatio});
    }, []);

    return null;
};

export default DataLayerDevicePixelRatio;
